/**
 * Returns the app base URL for redirects and links.
 * - When served locally (localhost / 127.0.0.1): returns current origin so redirects stay on local.
 * - When served on any other env (staging, pre-prod, prod): returns that env's URL from NEXT_PUBLIC_CJR_LINK.
 */
export function getAppBaseUrl(): string {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const isLocal = hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '';
    if (isLocal) {
      return window.location.origin;
    }
    return process.env.NEXT_PUBLIC_CJR_LINK || window.location.origin;
  }
  return process.env.NEXT_PUBLIC_CJR_LINK || '';
}
